export class Page<T> {
  constructor(
    readonly totalElements: number,
    readonly content: T[]
  ) {}

  getContent(): T[] {
    return [...this.content];
  }

  getTotalElements(): number {
    return this.totalElements;
  }
}
